/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import LanguageSelect from '../LanguageSelect';
import { selectArticle } from '../../selectors/edit';
import { selectScopes } from '../../selectors/scopes';
import { selectAllLanguages } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { updateArticle } from '../../actions/article/UpdateArticleActions';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EditArticleLanguageModal(props) {
  const dispatch = useAppDispatch();
  const article = useAppSelector(selectArticle);
  const languages = useAppSelector(selectAllLanguages);
  const scopes = useAppSelector(selectScopes);
  const kbLanguages = [languages.primaryLanguage, ...(languages.additionalLanguages || [])];
  const articleLanguage = article.values.hs_language;
  const [selectedLanguage, setSelectedLanguage] = useState(articleLanguage);
  const onSaveChangesClick = () => {
    dispatch(updateArticle(article, {
      values: {
        hs_language: selectedLanguage
      }
    }));
    props.onClose();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.header"
        })
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.articleCurrentLanguage",
          options: {
            currentLanguage: getLanguageNameFromCode(articleLanguage)
          }
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.languageField.label"
        }),
        children: /*#__PURE__*/_jsx(LanguageSelect
        // @ts-expect-error ts-migrate(2554)
        , {
          disabledLanguages: Object.keys(article.translations),
          knowledgeScopes: scopes,
          onChange: e => setSelectedLanguage(e.target.value),
          validLanguages: kbLanguages,
          value: selectedLanguage
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        disabled: selectedLanguage === articleLanguage,
        onClick: onSaveChangesClick,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.saveChangesButton"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: props.onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.edit.editLanguageModal.cancelButton"
        })
      })]
    })]
  });
}